exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-contri-redem-list{width:100%;margin-top:30px}.table-contri-redem-list .first-column{color:#24a3be !important;font-weight:normal}.table-contri-redem-list .btn-contri-redem{border-radius:1rem;background:#023874;width:163px;height:35px;padding:0;position:absolute;right:16px;top:-60px;cursor:pointer;z-index:999}.table-contri-redem-list .button{font-family:\"SF Pro Rounded\",sans-serif;padding:4px 10px;font-size:14px;height:auto;background-color:#d7d7d7;border:1px solid #909090;color:#909090}.table-contri-redem-list .button .icon{background-color:#f7f7f7;border-radius:100%}.table-contri-redem-list .button .icon i{font-size:18px}", ""]);

// exports
